const Skeleton = () => {
  return (
    <div
      className="flex max-w-[392px] animate-pulse flex-col gap-3 rounded-lg bg-white"
      role="status"
    >
      <div className="flex w-full items-center gap-3">
        <div className="size-14 rounded-full bg-gray-200"></div>
        <div className="my-auto flex flex-1 shrink basis-0 flex-col gap-2 self-stretch">
          <div className="h-6 w-48 rounded-full bg-gray-200"></div>
          <div className="h-4 max-w-[360px] rounded-full bg-gray-200"></div>
        </div>
      </div>
      <div className="mt-3 flex w-full flex-col gap-3">
        <div className="h-6 w-48 rounded-full bg-gray-200"></div>
        <div className="flex flex-col gap-3">
          <div className="h-4 max-w-[360px] rounded-full bg-gray-200"></div>
          <div className="h-4 max-w-[360px] rounded-full bg-gray-200"></div>
          <div className="h-4 max-w-[360px] rounded-full bg-gray-200"></div>
          <div className="h-4 max-w-[360px] rounded-full bg-gray-200"></div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
